var DeviceSearchTabsComponentController = (function () {
    function DeviceSearchTabsComponentController(deviceTypeSearch) {
        this.deviceTypeSearch = deviceTypeSearch;
        this.loading = false;
        this.lastSelected = false;
    }
    DeviceSearchTabsComponentController.prototype.$onInit = function () {
        var _this = this;
        this.loading = true;
        this.deviceTypeSearch
            .get()
            .then(function (items) {
            _this.tabs = items || [];
            _this.unselectAll();
            if (_this.tabs.length > 0 && _this.openFirst === 'true') {
                _this.tabs[0].selected = true;
            }
        })
            .finally(function () {
            _this.loading = false;
        });
    };
    DeviceSearchTabsComponentController.prototype.toggle = function (tab) {
        var state = tab.selected;
        this.unselectAll();
        tab.selected = !state;
    };
    DeviceSearchTabsComponentController.prototype.toggleLast = function () {
        var state = this.lastSelected;
        this.unselectAll();
        this.lastSelected = !state;
    };
    DeviceSearchTabsComponentController.prototype.unselectAll = function () {
        this.lastSelected = false;
        this.tabs.forEach(function (loopTab) {
            loopTab.selected = false;
        });
    };
    DeviceSearchTabsComponentController.$inject = ['deviceTypeSearch'];
    return DeviceSearchTabsComponentController;
}());
export var DeviceSearchTabsComponent = {
    bindings: {
        excludedDevices: '<?',
        onDevicesSelected: '&?',
        openFirst: '@?',
        scrollable: '<?',
        searchButtonLabel: '@',
    },
    controller: DeviceSearchTabsComponentController,
    templateUrl: 'compatibilityguide/ng-templates/feature/search/devicesearchtabs',
};
